module.exports = __webpack_public_path__ + "static/fonts/DIGITAL-Regular.331f46f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/comment/font/DIGITAL-Regular.ttf
// module id = 0VqS
// module chunks = 133